import React,{ useEffect, useState} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import Input from '../form/inputs/Input';
import "moment/locale/pl";
import CheckboxRadio from '../form/checkbox/CheckboxRadio';


const PublicCommited = ( props ) => {
    const dispatch                  = useDispatch()
    let taxArrears                  = useSelector(state => state.taxArrears)
    let taxArrearsPrice             = useSelector(state => state.taxArrearsPrice)
    let ZUSarrears                  = useSelector(state => state.ZUSarrears)
    let ZUSarrearsPrice             = useSelector(state => state.ZUSarrearsPrice)
    let enforcementProceedings      = useSelector(state => state.enforcementProceedings)
    let enforcementProceedingsPrice = useSelector(state => state.enforcementProceedingsPrice)
    let [ forceValidateTax, setForceValidateTax ] = useState(false);
    let [ forceValidateZus, setForceValidateZus ] = useState(false);
    let [ forceValidateProc, setForceValidateProc ] = useState(false);

    

    let validate = async () => {
        if ( taxArrears.length === 0) {
            await setForceValidateTax(true);
        } else {
            await setForceValidateTax(false);
        }

        if ( ZUSarrears.length === 0) {
            await setForceValidateZus(true);
        } else {
            await setForceValidateZus(false);
        }

        if ( enforcementProceedings.length === 0) {
            await setForceValidateProc(true);
        } else {
            await setForceValidateProc(false);
        }
    }

    useEffect(() => {
        if ( props.forceValidate ) {
            validate();
        }
    }, [props.forceValidate])

    useEffect(() => {
        if ( ZUSarrears.length > 0 ) {
            setForceValidateZus(false);
        }
    }, [ZUSarrears])

    useEffect(() => {
        if ( taxArrears.length > 0 ) {
            setForceValidateTax(false);
        }
    }, [taxArrears])

    useEffect(() => {
        if ( enforcementProceedings.length > 0 ) {
            setForceValidateProc(false);
        }
    }, [enforcementProceedings])


    return (
        <div className="public-commitment">
            <Heading title="Zobowiązania publicznoprawne" medium smallMargin />
            <div className="row-wrapper">
                <div className="row">
                    <Heading title="Zaległości podatkowe" small />
                    <div className="inputs">
                        <div className="col">
                            <CheckboxRadio   required={ true } 
                                            setFunction={ (val) =>  dispatch({ type: 'TAX_ARREARS_CHANGE', value: val })}
                                            forceValidate={ forceValidateTax }
                                            val={ taxArrears }
                                            text="Tak" />

                            <CheckboxRadio   required={ true } 
                                            setFunction={ (val) =>  dispatch({ type: 'TAX_ARREARS_CHANGE', value: val })}
                                            forceValidate={ forceValidateTax }
                                            text="Nie" 
                                            val={ taxArrears } />
                        </div>
                        <div className={ taxArrears == 'Tak' ? "col active" : "col"}>
                            { taxArrears == 'Tak' && 
                            <Input  name={"tax-arrears-price"}
                                id="tax-arrears-price"
                                required={ taxArrears == "Tak" ? true : false }
                                setFunction={ val =>  dispatch({ type: 'TAX_ARREARS_PRICE_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Kwota" }
                                val={ taxArrearsPrice }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } 
                                disabledForce={ (taxArrears == "Nie" ? true : false )}/>
                            }
                        
                        </div>
                    </div>
                    
                </div>
                
                <div className="row">
                    <Heading title="Zaległości ZUS" small />
                    <div className="inputs">
                        <div className="col">
                            <CheckboxRadio   required={ true } 
                                            setFunction={ (val) =>  dispatch({ type: 'ZUS_ARREARS_CHANGE', value: val })}
                                            forceValidate={ forceValidateZus }
                                            val={ ZUSarrears }
                                            text="Tak" />

                            <CheckboxRadio   required={ true } 
                                            setFunction={ (val) =>  dispatch({ type: 'ZUS_ARREARS_CHANGE', value: val })}
                                            forceValidate={ forceValidateZus }
                                            text="Nie" 
                                            val={ ZUSarrears } />
                        </div>
                        <div className={ ZUSarrears == 'Tak' ? "col active" : "col"}>
                        { ZUSarrears == 'Tak' && 
                            <Input  name={ "tax-arrears-price" }
                                    id="zus-arrears-price"
                                    required={ ZUSarrears == "Tak" ? true : false }
                                    setFunction={ val =>  dispatch({ type: 'ZUS_ARREARS_PRICE_CHANGE', value: val }) }
                                    type="text"
                                    placehold={ "Kwota" }
                                    val={ ZUSarrearsPrice }
                                    size="xxl" 
                                    formatPrice={ true }
                                    regExp={/^[0-9\,\.\s]+$/}
                                    allowChars={/^[0-9\,\.\s]+$/}
                                    minChar={ 0 } 
                                    forceValidate={ props.forceValidate } 
                                    disabledForce={ (ZUSarrears == "Nie" ? true : false )}/>
                        }
                        </div>
                    </div>
                    
                </div>

                <div className="row">
                    <Heading title="Postępowanie egzekucyjne" small />
                    <div className="inputs">
                        <div className="col">
                            <CheckboxRadio   required={ true } 
                                            setFunction={ (val) =>  dispatch({ type: 'ENFORCEMENT_PROCEEDINGS_CHANGE', value: val })}
                                            forceValidate={ forceValidateProc }
                                            val={ enforcementProceedings }
                                            text="Tak" />

                            <CheckboxRadio   required={ true } 
                                            setFunction={ (val) =>  dispatch({ type: 'ENFORCEMENT_PROCEEDINGS_CHANGE', value: val })}
                                            forceValidate={ forceValidateProc }
                                            text="Nie" 
                                            val={ enforcementProceedings } />
                        </div>
                        <div className={ enforcementProceedings == 'Tak' ? "col active" : "col"}>
                            { enforcementProceedings == 'Tak' && 
                            <Input  name={"enforcement-proceedings-price"}
                                    id="enforcement-proceedings-price"
                                    required={ enforcementProceedings == "Tak" ? true : false }
                                    setFunction={ val =>  dispatch({ type: 'ENFORCEMENT_PROCEEDINGS_PRICE_CHANGE', value: val }) }
                                    type="text"
                                    placehold={ "Kwota" }
                                    val={ enforcementProceedingsPrice }
                                    size="xxl" 
                                    formatPrice={ true }
                                    regExp={/^[0-9\,\.\s]+$/}
                                    allowChars={/^[0-9\,\.\s]+$/}
                                    minChar={ 0 } 
                                    forceValidate={ props.forceValidate } 
                                    disabledForce={ (enforcementProceedings == "Nie" ? true : false )}/>
                            }
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default PublicCommited;